var Config = {
    initialized: false,
    wsUrl: "/api/sds",
    downloadWsUrl: "/api/download/save",
    productsPerPage: 10,
    showAllDocuments: true,
    sdsFileTitleFormat: "SDS for {country} version {version} ({language})",
    allowBulkNumberSearch: false,
    searchBackground: "#d5edf9",
    init() {
        if (this.initialized) return;
        
        this.wsUrl = this.getElementValue("doc-finder-wsurl", this.wsUrl);
        this.downloadWsUrl = this.getElementValue("download-wsurl", this.downloadWsUrl);
        this.sdsFileTitleFormat = this.getElementValue("sds-file-title-format", this.sdsFileTitleFormat);
        let ppp = this.getElementValue("products-per-page", this.wsUrl);
        if (ppp) {
            this.productsPerPage = parseInt(ppp);
        }
        let sad = this.getElementValue("show-all-documents", "");
        if (sad) {
            this.showAllDocuments = (sad === "true" || sad === "1");
        }
        let abns = this.getElementValue("allow-bulk-number-search", "0");
        if (abns) {
            this.allowBulkNumberSearch = (abns === "true" || abns === "1");
        }
        this.searchBackground = this.getElementValue("search-background", this.searchBackground);
        this.initialized = true;
    },
    getElementValue(id, defaultValue) {
        var el = document.getElementById(id);
        if (el) return el.value || defaultValue;
        else return defaultValue;
    }
};

export default Config;